<template>
    <div class="relative">
        <!-- Floating Label -->
        <label
            :class="labelClasses"
            class="absolute transition-all duration-200 pointer-events-none z-50"
        >
            {{ label }}
        </label>

        <!-- File Input Container -->
        <div class="relative">
            <!-- Hidden File Input -->
            <input
                ref="fileInput"
                type="file"
                :accept="accept"
                @change="handleFileChange"
                class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                :multiple="multiple"
            />

            <!-- Styled Input Display -->
            <div
                :class="inputClasses"
                class="w-full h-12 px-4 py-3 border rounded-md bg-white cursor-pointer flex items-center justify-between"
            >
            <span class="text-gray-700 truncate">
              {{ displayText }}
            </span>

                <!-- Attachment Icon -->
                <svg
                    class="w-5 h-5 text-gray-400 flex-shrink-0 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
    label: {
        type: String,
        default: 'File *'
    },
    accept: {
        type: String,
        default: ''
    },
    multiple: {
        type: Boolean,
        default: false
    },
})

const emit = defineEmits(['change'])

const fileInput = ref(null)
const selectedFiles = ref([])

const hasFiles = computed(() => selectedFiles.value.length > 0)

const displayText = computed(() => {

    if (props.multiple) {
        return selectedFiles.value.length === 1
            ? selectedFiles.value[0].name
            : `${selectedFiles.value.length} files selected`
    }

    return selectedFiles.value[0]?.name
})

const labelClasses = computed(() => {
    return hasFiles.value
        ? 'text-xs text-primary -top-2 left-3 bg-white px-1'
        : 'text-base text-gray-500 top-3 left-4'
})

const inputClasses = computed(() => {
    return hasFiles.value
        ? 'border-gray-300 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500'
        : 'border-gray-300 hover:border-gray-400 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500'
})

const handleFileChange = (event) => {
    const files = Array.from(event.target.files || [])
    selectedFiles.value = files
    emit('change', props.multiple ? files : files[0])
}
</script>

